import React from "react";
import { style } from "./PopUp.css";
import { Button, Dialog, Box, Typography, TextField } from "@mui/material";
import PopUpImg from "../Image/popUp.png";
import CancelIcon from "@mui/icons-material/Cancel";

const PopUp = ({ open, setOpen, setCounter, inputRef }) => {
  const handleClose = () => {
    setOpen(false);
  };

  /* regex for email address */
  const emailRegex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

  /* regex for name */
  const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

  const companyRegex = /^[a-zA-Z]+$/;


  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [nameErrorText, setNameErrorText] = React.useState("");
  const [emailErrorText, setEmailErrorText] = React.useState("");
  const [companyErrorText, setCompanyErrorText] = React.useState("");

  const formHandler = (e) => {
    e.preventDefault();
    if (!name) {
      setNameErrorText("Please enter name");
    } else if (!nameRegex.test(name)) {
      setNameErrorText(
        "Name must contain only uppercase and lowercase letter. Space is not allowed while entering the name."
      );
    } else if (name.length < 2) {
      setNameErrorText("Name should be more than 1 character");
    } else {
      setNameErrorText("");
    }
    if (!email) {
      setEmailErrorText("Please enter email");
    } else if (!emailRegex.test(email)) {
      setEmailErrorText("Enter valid email address");
    } else {
      setEmailErrorText("");
    }
    if (!company) {
      setCompanyErrorText("Please enter company name");
    } else if (!companyRegex.test(company)) {
      setCompanyErrorText("Enter valid company name");
    } else {
      setCompanyErrorText("");
    }
    if (
      !email === false &&
      !name === false &&
      !company === false &&
      nameRegex.test(name) === true &&
      emailRegex.test(email) === true &&
      companyRegex.test(company) === true &&
      name.length > 1
    ) {
      setOpen(false);
      setCounter((preValue) => preValue + 1);
      inputRef.current.disabled = false;
    }

    let showData = JSON.parse(window.sessionStorage.getItem("data"));

    window.sessionStorage.removeItem("data");

    window.sessionStorage.setItem(
      "data",
      JSON.stringify({
        sessionid: showData.sessionid,
        name: name,
        email: email,
        company: company,
      })
    );

    fetch(`${process.env.REACT_APP_BACKEND}/api/information`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        question: "",
        newconversation: false,
        sessionid: showData.sessionid,
        name: name,
        email: email,
        company: company,
      }),
    });
  };

  const closeHandler = () => {
    setOpen(false);
  };

  return (
    <Box>
      <Dialog onClose={handleClose} open={open} sx={style.dialogBox}>
        <CancelIcon sx={style.cancelIcon} onClick={closeHandler} />
        <Box sx={style.mainBox}>
          <Box>
            <Box component="img" src={PopUpImg} sx={style.img} />
          </Box>
          <Box>
            <Box sx={style.forMobile}>
              <form noValidate>
                <Box sx={style.fieldBox}>
                <Typography sx={style.topText}>
                Hey there! We'd love to stay connected with you.
              </Typography>
                  <TextField
                    label="Name"
                    variant="outlined"
                    fullWidth
                    sx={style.textField}
                    required
                    name="name"
                    value={name}
                    error={!!nameErrorText}
                    helperText={nameErrorText}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    sx={style.textField}
                    required
                    name="email"
                    value={email}
                    error={!!emailErrorText}
                    helperText={emailErrorText}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <TextField
                    label="Company Name"
                    variant="outlined"
                    fullWidth
                    sx={style.textField}
                    name="company"
                    value={company}
                    error={!!companyErrorText}
                    helperText={companyErrorText}
                    onChange={(e) => setCompany(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    onClick={formHandler}
                    sx={style.submitBtn}
                  >
                    Submit
                  </Button>
                </Box>
              </form>
            </Box>
          </Box>
          <Box sx={style.lastParent}>
            <Typography sx={style.starColor}>*</Typography>
            <Typography sx={style.lastText}>
              To ensure we can provide you with the best possible assistance and
              keep you in the loop with the latest updates, we kindly request
              you to share your contact details with us. Thanks a bunch!
            </Typography>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default PopUp;
